import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import References from "../../components/References";
import LdsBlockSteps from "../../components/LdsBlockSteps";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.3.8 Reminder: The 5 Steps for Reading Amyvid PET Scans
            </h1>
            <p className="me-4">Estimated time to complete: 1 minute</p>
          </section>

          <section className="row justify-content-center mt-5 mb-3">
            <div className="col-12 align-items-center">
              <LdsBlockSteps />
            </div>
          </section>

          <section className="row justify-content-center mt-5 mb-5">
            <div className="col-12 align-items-center">
              <p>
                This training uses MIM software. As there are differences
                between the commercially available software, please consult your
                specific software manufacturer for more detailed training and
                orientation.
              </p>
              <h5 className="b text-uppercase mb-3 mt-3">Select Important Safety Information</h5>
              <p><strong>Risk for Image Misinterpretation and Other Errors</strong></p>
              <p>
                Errors may occur during Amyvid image interpretation. Image
                interpretation should be performed independently of the
                patient's clinical information. Amyvid scan results are
                indicative of plaque content only at the time of image
                acquisition and a negative scan does not preclude the
                development of brain amyloid in the future.
              </p>
            </div>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-3-7", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-2/module-2-4-0", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>

          <References>
            <p className="fz-sm gray">
              Amyvid (florbetapir F 18 injection) Prescribing Information. Lilly
              USA, LLC.
            </p>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
